import React, { useState, useEffect } from "react";
import { customerApi } from "../../api/client";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Alert from "@mui/material/Alert";

export default function AccountPaymentMethods() {
  const [data, setData] = useState({ razorpay_customer_id: null, cards: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [removing, setRemoving] = useState(null);

  const load = () => {
    setError("");
    setLoading(true);
    customerApi("/api/customer/payment-methods")
      .then(setData)
      .catch((e) => setError(e.message || "Failed to load cards"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const remove = async (tokenId) => {
    setRemoving(tokenId);
    setError("");
    try {
      await customerApi(`/api/customer/payment-methods/${encodeURIComponent(tokenId)}`, {
        method: "DELETE",
      });
      await load();
    } catch (e) {
      setError(e.message || "Could not remove card");
    } finally {
      setRemoving(null);
    }
  };

  if (loading) return <Typography>Loading…</Typography>;

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        Saved cards
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Cards are stored securely by Razorpay. You can remove a card here anytime.
      </Typography>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {!data.razorpay_customer_id && data.cards.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No saved cards yet. Pay with card while signed in and choose &quot;Save card for next time&quot; on the payment page.
        </Typography>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {data.cards.map((c) => (
            <Card key={c.id} variant="outlined">
              <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 2, "&:last-child": { pb: 2 } }}>
                <Box>
                  <Typography variant="subtitle1" fontWeight={600}>
                    {c.network || "Card"} •••• {c.last4 || "****"}
                  </Typography>
                  {(c.name || c.issuer) && (
                    <Typography variant="caption" color="text.secondary">
                      {[c.name, c.issuer].filter(Boolean).join(" · ")}
                    </Typography>
                  )}
                </Box>
                <Button
                  size="small"
                  color="error"
                  variant="outlined"
                  disabled={removing === c.id}
                  onClick={() => remove(c.id)}
                >
                  {removing === c.id ? "Removing…" : "Remove"}
                </Button>
              </CardContent>
            </Card>
          ))}
        </Box>
      )}
    </Box>
  );
}
